import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import type { SxProps, Theme } from "~/common/mui";
import { Button, Typography } from "~/common/mui";

type AccordionSummaryToggleProps = {
  open: boolean;
  onClick?: () => void;
  showLabel: string;
  hideLabel: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
};

export const AccordionSummaryToggle = ({
  open,
  onClick,
  showLabel,
  hideLabel,
  disabled,
  sx,
}: AccordionSummaryToggleProps) => {
  return (
    <Button
      variant="text"
      color="textPrimary"
      startIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      onClick={onClick}
      disabled={disabled}
      sx={sx}
    >
      <Typography variant="labelLarge" fontWeight="normal">
        {open ? hideLabel : showLabel}
      </Typography>
    </Button>
  );
};
